
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetohyderabad() {



  const cardData =
  {
    keyword: 'Pune to Hyderabad Cabs',
    heading: 'AB Ghule Cabs: Pune to Hyderabad Cabs',
    headingDescription: 'Planning a trip from Pune to Hyderabad? AB Ghule Cabs provides comfortable, safe, and affordable taxi services to ensure your journey is enjoyable and stress-free. Whether you are traveling for business, leisure, or a family outing, our fleet of well-maintained vehicles and professional drivers make the Pune to Hyderabad trip seamless. The approximate distance from Pune to Hyderabad is around 660 km.',

    top: 'Top Places to Visit in Hyderabad with AB Ghule Cabs',

   "topPlaces": [
  {
    title: "Charminar",
    description: "Hyderabad’s most iconic landmark, the Charminar, is a must-visit. This historical monument is a blend of Indo-Islamic architecture and is surrounded by bustling markets."
  },
  {
    title: "Golconda Fort",
    description: "A historic citadel known for its impressive architecture and acoustics, Golconda Fort offers panoramic views of the city and is a significant part of Hyderabad’s history."
  },
  {
    title: "Hussain Sagar Lake",
    description: "A beautiful man-made lake in the heart of the city, Hussain Sagar is perfect for boat rides and a peaceful evening stroll. The Buddha statue situated in the middle of the lake is a popular sight."
  },
  {
    title: "Qutb Shahi Tombs",
    description: "A collection of tombs belonging to the Qutb Shahi dynasty, this place is a testament to Hyderabad’s royal past and showcases stunning Mughal and Persian architecture."
  },
  {
    title: "Ramoji Film City",
    description: "One of the largest film studio complexes in the world, Ramoji Film City is a popular tourist destination offering guided tours, entertainment shows, and movie sets to explore."
  },
  {
    title: "Salar Jung Museum",
    description: "This museum houses an extensive collection of art, sculptures, textiles, and manuscripts from around the world. It is one of the largest museums in India and a must-visit for art enthusiasts."
  },
  {
    title: "Chilkur Balaji Temple",
    description: "Known as the 'Visa Balaji Temple,' this spiritual destination is located near Hyderabad and attracts devotees seeking blessings for their visa applications."
  },
  {
    title: "Necklace Road",
    description: "A scenic road around Hussain Sagar Lake, Necklace Road offers a delightful view of the water and the city’s skyline. It's ideal for evening walks, cycling, and casual outings."
  },
  {
    title: "Laad Bazaar",
    description: "Located near Charminar, Laad Bazaar is famous for its wide range of bangles, pearls, and traditional Hyderabadi jewelry. It’s a great spot to shop for souvenirs."
  },
  {
    title: "Birla Mandir",
    description: "This beautiful temple dedicated to Lord Venkateshwara offers panoramic views of Hyderabad and is known for its serene atmosphere and stunning architecture."
  }
],


services: [
    {
      "name": "Pune to Hyderabad Cabs",
      description: "Travel comfortably and safely with AB Ghule Cabs from Pune to Hyderabad. We ensure that every journey is a smooth one by offering a wide range of well-maintained vehicles. Whether you are traveling for business, leisure, or a family getaway, our drivers are experienced, courteous, and committed to providing a hassle-free and enjoyable trip. Book with us for a reliable service with flexible travel options."
    },
    {
      "name": "Pune to Hyderabad Taxi Booking",
      description: "Booking your taxi from Pune to Hyderabad is easy and convenient with AB Ghule Cabs. Our user-friendly online booking platform allows you to secure a taxi in just a few clicks. Whether you’re looking for a one-way ride or a round trip, we offer flexible options to meet your travel preferences. Enjoy a seamless booking experience with guaranteed quality service and on-time arrivals."
    },
    {
      "name": "Pune to Hyderabad Car Rental",
      description: "If you're looking to rent a car from Pune to Hyderabad, AB Ghule Cabs has a diverse fleet of vehicles to cater to all your travel needs. Choose from a variety of cars, including compact sedans, luxurious SUVs, or even larger vehicles for group travel. Our rental cars come with a skilled driver who knows the best routes, ensuring you have a comfortable and smooth journey. We guarantee clean, well-maintained cars for your trip."
    },
    {
      "name": "Pune to Hyderabad Taxi Rates",
      description: "Our Pune to Hyderabad taxi rates are designed to be affordable and transparent. We believe in providing value for money without compromising on quality or comfort. Our rates are competitive, and we make sure there are no hidden fees. Whether you need a short trip or a round trip, we ensure that the pricing is clear and fair, so you can budget your travel with ease."
    },
    {
      "name": "Pune to Hyderabad Cab Charges",
      description: "AB Ghule Cabs offers affordable and transparent cab charges from Pune to Hyderabad. Our pricing is straightforward with no hidden costs. We factor in distance, time, and vehicle type to provide the best possible pricing, ensuring you get excellent value for your money. Whether you’re traveling solo or with family, we have the right vehicle to meet your needs."
    },
    {
      "name": "Pune to Hyderabad Cab Pricing",
      description: "At AB Ghule Cabs, we offer clear and transparent Pune to Hyderabad cab pricing based on the distance, time, and type of vehicle you choose. Whether you're opting for an economy car or a premium SUV, we ensure that the prices are affordable, so you don’t need to worry about unexpected charges. Our goal is to make your travel budget-friendly while ensuring comfort throughout your journey."
    },
    {
      "name": "Pune to Hyderabad Private Car Hire",
      description: "For those who prefer privacy, comfort, and flexibility, booking a private car hire from Pune to Hyderabad with AB Ghule Cabs is the perfect choice. We offer a wide selection of cars, from sedans to luxury vehicles, each ensuring an exclusive travel experience. Whether you need privacy for a business trip or a relaxing family journey, our private car hire service guarantees your comfort and convenience."
    },
    {
      "name": "Pune to Hyderabad Cab Cost",
      description: "The cost of your Pune to Hyderabad cab ride depends on the vehicle type, route, and duration of your journey. We offer transparent and competitive pricing, ensuring that you get the best value for your trip. Whether you need a budget-friendly sedan or a luxury SUV, we ensure the cab cost is affordable while maintaining high-quality service."
    },
    {
      "name": "Pune to Hyderabad Taxi Service",
      description: "Our Pune to Hyderabad taxi service is reliable, punctual, and designed to provide you with a comfortable and enjoyable travel experience. AB Ghule Cabs takes pride in offering excellent customer service, with professional drivers, well-maintained cars, and smooth rides. We are dedicated to ensuring your journey is stress-free, whether you're traveling for business, leisure, or a family outing."
    },
    {
      "name": "Pune to Hyderabad Cabs",
      description: "AB Ghule Cabs offers a variety of Pune to Hyderabad cabs to suit your specific needs. Whether you're traveling solo, with family, or in a group, we have a wide range of vehicles, including sedans, SUVs, and luxury cars, to ensure a comfortable journey. We provide easy online booking, clear pricing, and a commitment to excellent service, making your journey from Pune to Hyderabad a pleasant experience."
    },
    {
      "name": "Cab from Pune to Hyderabad",
      description: "Planning to travel from Pune to Hyderabad? Choose AB Ghule Cabs for an affordable and comfortable cab service. We ensure a smooth and safe ride, with a variety of vehicles to match your travel requirements. Our experienced drivers know the best routes to ensure timely arrivals. With our well-maintained fleet and excellent customer service, we guarantee you a hassle-free journey from start to finish."
    },
    {
      "name": "Pune to Hyderabad Taxi",
      description: "Book your Pune to Hyderabad taxi with AB Ghule Cabs for a hassle-free, reliable, and comfortable journey. We offer a wide selection of vehicles to choose from, including sedans, SUVs, and more. Our professional drivers are committed to providing the best service, ensuring that your ride is smooth, comfortable, and on time. Let us take the stress out of your travel and provide you with the best experience possible."
    },
    {
      "name": "Pune to Hyderabad Airport Cab",
      description: "Need a ride to or from the airport? AB Ghule Cabs offers reliable Pune to Hyderabad airport taxi services, ensuring you arrive on time for your flight or when you land. Our professional drivers are familiar with airport routes and traffic patterns to provide you with the most efficient and stress-free airport transfer experience. Book your airport cab service today for a punctual and smooth ride."
    },
    {
      "name": "Pune to Telangana Cab Service",
      description: "AB Ghule Cabs offers seamless travel services from Pune to Hyderabad and other destinations in Telangana. We ensure comfortable and safe travel for both business and leisure trips. Whether you're heading to Hyderabad, Warangal, or any other city in Telangana, our reliable cab services are the ideal way to get there. Our fleet includes vehicles that cater to solo travelers, families, and large groups."
    },
    {
      "name": "Pune to Mysore Ooty Package",
      description: "Planning a trip to Mysore and Ooty from Pune? AB Ghule Cabs offers customizable Pune to Mysore Ooty packages that combine sightseeing, comfort, and affordability. Explore the scenic beauty of Ooty's hills and Mysore's historical landmarks with our all-inclusive travel package. From transportation to sightseeing, we take care of all the details, ensuring that your vacation is memorable and stress-free."
    },
    {
      "name": "Pune to Hyderabad Innova Crysta",
      description: "For a luxurious and comfortable ride from Pune to Hyderabad, book the Innova Crysta with AB Ghule Cabs. Known for its spacious interiors, superior comfort, and modern amenities, the Innova Crysta is the perfect vehicle for families or small groups traveling together. Enjoy a smooth and stress-free journey with a professional driver who ensures your trip is safe and pleasant from start to finish."
    },
    {
      "name": "Pune to Hyderabad Tempo Traveller on Rent",
      description: "Traveling in a group? AB Ghule Cabs offers the perfect solution with our Tempo Traveller on rent for your Pune to Hyderabad journey. With ample seating, spacious interiors, and a comfortable environment, our Tempo Travellers are ideal for larger groups or families. Enjoy a relaxed, enjoyable ride while our professional driver handles the journey, ensuring a smooth and punctual trip."
    },
    {
      "name": "Pune to Hyderabad Sedan Cabs",
      description: "For a compact, budget-friendly, and efficient ride, AB Ghule Cabs offers sedan cabs from Pune to Hyderabad. Our fleet includes popular models like Swift Dzire and Toyota Etios, which are perfect for solo travelers or small groups. Enjoy a smooth, economical ride without compromising on comfort, with a professional driver to ensure your safety and convenience."
    },
    {
      "name": "Pune to Hyderabad Cabs Contact Number",
      description: "For any queries or to book your Pune to Hyderabad cab, contact AB Ghule Cabs at +91 8624029699. Our customer support team is available to assist you with your booking, answer your questions, and provide any additional information you may need. We are committed to providing excellent customer service and ensuring your travel experience is seamless and comfortable."
    }
  ],

  tableData: [
    ["Pune to Hyderabad Cabs", "-Pune to Hyderabad Taxi Booking"],
    ["Pune to Hyderabad Car Rental", "-Pune to Hyderabad Taxi Rates"],
    ["Pune to Hyderabad Cab Charges", "-Pune to Hyderabad Cab Pricing"],
    ["Pune to Hyderabad Private Car Hire", "-Pune to Hyderabad Cab Cost"],
    ["Pune to Hyderabad Taxi Service", "-Pune to hyderabad cabs"],
    ["Cab from pune to hyderabad", "-Pune to Hyderabad Taxi"],
    ["Pune to hyderabad airport cab", "-Pune to telangana cab service"],
    ["Pune to mysore ooty package", "-Pune to hyderabad innova crysta"],
    ["Pune to hyderabad tempo traveller on rent", "-Pune to hyderabad Sedan cabs"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "AB Ghule Cabs offers a reliable, professional, and comfortable taxi service from Pune to Hyderabad. We ensure that your journey is smooth, timely, and stress-free with our experienced drivers and well-maintained vehicles."
    },
    {
      WhyChooseheading: "Affordable Pricing",
      WhyChoosedescription: "We offer affordable and transparent pricing for all our trips. Whether you're traveling for business or leisure, we ensure that you get the best value for your money with no hidden charges."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "Our fleet of vehicles is regularly cleaned, inspected, and maintained to provide you with the best travel experience. You can choose from a variety of vehicles, including sedans, SUVs, and luxury cars, based on your preferences."
    },
    {
      WhyChooseheading: "Experienced and Courteous Drivers",
      WhyChoosedescription: "All our drivers are well-trained, experienced, and professional. They are familiar with the best routes from Pune to Hyderabad, ensuring that you reach your destination safely and on time."
    },
    {
      WhyChooseheading: "On-Time Pick-Up and Drop-Off",
      WhyChoosedescription: "Our drivers ensure punctual pick-up from your desired location in Pune and drop-off at your destination in Hyderabad. We understand the importance of time and ensure that your travel is hassle-free."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "No matter the time of day or night, AB Ghule Cabs is available 24/7 to assist you with your Pune to Hyderabad journey. Our customer support team is always ready to assist with bookings."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "You can easily book your Pune to Hyderabad cab through our website, mobile app, or by calling our customer service. We offer a simple and quick booking process for your convenience."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a taxi from Pune to Hyderabad?',
      answer: 'You can easily book a taxi through our website, mobile app, or by calling our customer service team.',
    },
    {
      id: 'FAQ2',
      question: 'What is the fare for a one-way trip from Pune to Hyderabad?',
      answer: 'The one-way fare for a sedan typically ranges from ₹7,000 to ₹8,500, depending on the vehicle type.',
    },
    {
      id: 'FAQ3',
      question: 'Are the fares inclusive of taxes and tolls?',
      answer: 'Yes, the fares are inclusive of all taxes, tolls, and other charges.',
    },
    {
      id: 'FAQ4',
      question: 'How long will the journey from Pune to Hyderabad take?',
      answer: 'The journey usually takes around 10 to 12 hours, depending on traffic conditions and the route taken.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round-trip from Pune to Hyderabad?',
      answer: 'Yes, we offer round-trip bookings as well. You can inquire about the best rates for a round trip to Hyderabad.',
    },
    {
      id: 'FAQ6',
      question: 'Can I choose my pick-up location in Pune?',
      answer: 'Yes, we offer pick-up from any location in Pune, whether it’s your residence, office, or hotel.',
    },
    {
      id: 'FAQ7',
      question: 'Are the vehicles air-conditioned?',
      answer: 'Yes, all our vehicles are air-conditioned, ensuring you have a comfortable ride.',
    },
    {
      id: 'FAQ8',
      question: 'How do I pay for the ride?',
      answer: 'Payments can be made via cash, credit/debit card, or through our mobile app, making it convenient for you.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any extra charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, but we always inform you about these charges in advance.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Amit Desai',
      feedback: 'I booked a cab from Pune to Hyderabad, and the experience was fantastic! The driver was professional, and the car was clean and comfortable. The journey was smooth, and we reached on time. Highly recommend AB Ghule Cabs!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Rina Patel',
      feedback: 'AB Ghule Cabs made my long journey from Pune to Hyderabad extremely comfortable. The driver was courteous, and the car was well-maintained. I will definitely choose them again for my future trips.',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Hyderabad Cabs | Affordable Taxi & Car Rental Services</title>
  <meta name="description" content="Book a taxi from Pune to Hyderabad with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Hyderabad Cabs, Pune to Hyderabad Taxi Booking, Pune to Hyderabad Car Rental, Pune to Hyderabad Taxi Rates, Pune to Hyderabad Cab Charges, Pune to Hyderabad Cab Pricing, Pune to Hyderabad Private Car Hire, Pune to Hyderabad Cab Cost, Pune to Hyderabad Taxi Service, Pune to Hyderabad Cabs, Cab from Pune to Hyderabad, Pune to Hyderabad Taxi, Pune to Hyderabad Airport Cab, Pune to Telangana Cab Service, Pune to Mysore Ooty Package, Pune to Hyderabad Innova Crysta, Pune to Hyderabad Tempo Traveller on Rent, Pune to Hyderabad Sedan Cabs" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Hyderabad Cabs | Affordable Taxi & Car Rental Services" />
  <meta property="og:description" content="Book a taxi from Pune to Hyderabad with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-hyderabad-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-hyderabad-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Hyderabad Cabs",
        description: "Book a taxi from Pune to Hyderabad with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-hyderabad-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-hyderabad-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-hyderabad-cabs.jpg",
        "priceRange": "₹5000 - ₹12000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-hyderabad-cabs",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "150"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anil K"
            },
            "datePublished": "2024-11-10",
            "reviewBody": "Booked a cab for Pune to Hyderabad. The driver was excellent, and the ride was smooth. I highly recommend AB Ghule Cabs!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha R"
            },
            "datePublished": "2024-09-05",
            "reviewBody": "Great experience with AB Ghule Cabs on our trip from Pune to Hyderabad. The vehicle was well-maintained and the driver very professional."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Hyderabad Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-hyderabad-cabs"
        },
        "keywords": "Pune to Hyderabad Cabs, Pune to Hyderabad Taxi Booking, Pune to Hyderabad Car Rental, Pune to Hyderabad Taxi Rates, Pune to Hyderabad Cab Charges, Pune to Hyderabad Cab Pricing, Pune to Hyderabad Private Car Hire, Pune to Hyderabad Cab Cost, Pune to Hyderabad Taxi Service, Pune to Hyderabad Cabs, Cab from Pune to Hyderabad, Pune to Hyderabad Taxi, Pune to Hyderabad Airport Cab, Pune to Telangana Cab Service, Pune to Mysore Ooty Package, Pune to Hyderabad Innova Crysta, Pune to Hyderabad Tempo Traveller on Rent, Pune to Hyderabad Sedan Cabs"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/54.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetohyderabad;